/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type LiveMoversQueryVariables = {|
  eventId: string,
  round: number,
|};
export type LiveMoversQueryResponse = {|
  +pgaTopMovers: ?{|
    +risers: ?$ReadOnlyArray<?{|
      +id: string,
      +positionMovementValue: ?number,
    |}>,
    +fallers: ?$ReadOnlyArray<?{|
      +id: string,
      +positionMovementValue: ?number,
    |}>,
  |}
|};
export type LiveMoversQuery = {|
  variables: LiveMoversQueryVariables,
  response: LiveMoversQueryResponse,
|};
*/


/*
query LiveMoversQuery(
  $eventId: ID!
  $round: Int!
) {
  pgaTopMovers(eventId: $eventId, eventRound: $round) {
    risers {
      id
      positionMovementValue
    }
    fallers {
      id
      positionMovementValue
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "eventId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "round"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "id",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "positionMovementValue",
    "storageKey": null
  }
],
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "eventId",
        "variableName": "eventId"
      },
      {
        "kind": "Variable",
        "name": "eventRound",
        "variableName": "round"
      }
    ],
    "concreteType": "PGATourTopMoversType",
    "kind": "LinkedField",
    "name": "pgaTopMovers",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourEventRoundType",
        "kind": "LinkedField",
        "name": "risers",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PGATourEventRoundType",
        "kind": "LinkedField",
        "name": "fallers",
        "plural": true,
        "selections": (v1/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveMoversQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "LiveMoversQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "17951850d3df9a99d28d64473568af1a",
    "id": null,
    "metadata": {},
    "name": "LiveMoversQuery",
    "operationKind": "query",
    "text": "query LiveMoversQuery(\n  $eventId: ID!\n  $round: Int!\n) {\n  pgaTopMovers(eventId: $eventId, eventRound: $round) {\n    risers {\n      id\n      positionMovementValue\n    }\n    fallers {\n      id\n      positionMovementValue\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a0557d7c55d6059c68100d00b4d9b482';

module.exports = node;
